import * as angular from "angular";

export class TeamColorDataProvider {
    // All colours keep white avatar/header text readable (≥3:1 contrast).
    // Ordered as a rainbow by hue (red → orange → green → blue → purple →
    // magenta → pink).
    public readonly teamColours = [
        "#ff1b38", // bright red
        "#d0021b", // red
        "#6d4c41", // brown
        "#cc530f", // burnt orange
        "#b45309", // amber
        "#4d7c0f", // olive
        "#198c59", // light green
        "#0a613b", // green
        "#0e7490", // cyan
        "#00637f", // teal
        "#0664af", // dark blue
        "#475569", // slate
        "#4986E7", // blue
        "#2f3292", // navy
        "#4f46e5", // indigo
        "#8e68c6", // purple
        "#9800ff", // dark purple
        "#c026d3", // fuchsia
        "#d954e3", // pink purple
        "#ff1961", // pink
        "#cb4064", // faded red
        "#be123c", // rose
    ];

    randomColor(): string {
        const rand = Math.floor(Math.random() * this.teamColours.length);
        return this.teamColours[rand];
    }
}

angular
    .module("vcDataProvider")
    .service("TeamColorDataProvider", TeamColorDataProvider);
